import { NumberData } from '@/types/common';

export enum BusinessType {
  FINANCE = 1,
  CAR_SECURITY = 2,
  SEQUAL = 3,
  TOKAI_RIKA = 4
}

export const getBusinessTypeLabel = (
  businessType: number,
  labels: NumberData | null = null
) => {
  return labels?.[businessType] ?? '-';
};
